import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postExtensiveAttributeDefinitions } from 'api/extensive-attribute-definition.service';
import { UserExtensiveAttributeDefinitionsRequest } from 'types/entity';

export const EXTENSIVE_ATTRIBUTE_DEFINITION_CREATE_STORE_NAME = 'extensiveAttributeDefinitionCreate';

export const createExtensiveAttributeDefinitions = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_DEFINITION_CREATE_STORE_NAME}/create`,
  (payload: { projectId: string, attributes: UserExtensiveAttributeDefinitionsRequest}, thunkAPI) => {
    const { projectId, attributes } = payload;
    return postExtensiveAttributeDefinitions(projectId, attributes);
  },
);

export interface ExtendiveAttributeDefinitionCreateState {
  processing: boolean
  savedDefinitionId?: string
  error: any
}

export const initialExtensiveAttributeDefinitionCreateState: ExtendiveAttributeDefinitionCreateState = {
  processing: false,
  error: null,
};

export const extensiveAttributeDefinitionCreateSlice = createSlice({
  name: EXTENSIVE_ATTRIBUTE_DEFINITION_CREATE_STORE_NAME,
  initialState: initialExtensiveAttributeDefinitionCreateState,
  reducers: {
    clear: (state) => {
      state.error = initialExtensiveAttributeDefinitionCreateState.error;
      state.processing = initialExtensiveAttributeDefinitionCreateState.processing;
      state.savedDefinitionId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createExtensiveAttributeDefinitions.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(createExtensiveAttributeDefinitions.fulfilled, (state, action) => {
      state.processing = false;
      state.savedDefinitionId = action.payload.extensive_attribute_definition_id;
    });
    builder.addCase(createExtensiveAttributeDefinitions.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const extensiveAttributeDefinitionCreateActions = {
  ...extensiveAttributeDefinitionCreateSlice.actions,
  createExtensiveAttributeDefinitions,
};

export default extensiveAttributeDefinitionCreateSlice.reducer;
